export default __webpack_public_path__ + "static/media/instructions-arrow.2af71e1d.svg";